module.exports = __webpack_public_path__ + "static/media/dancers-orange.4763a73b.png";